import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
// reactstrap components
import {
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Form,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  InputGroup,
  Navbar,
  Nav,
  Container,
  Media,
} from "reactstrap";
import { logout, getProfileInfo } from "../../network/ApiAxios";
import {apiRoot,ddns} from '../../../package.json'

const AdminNavbar = (props) => {
  const [pic, setpic] = useState();
  const history = useHistory();

  useEffect(() => {
    getProfilePic();
    // eslint-disable-next-line
  }, []);

  let username = JSON.parse(localStorage.getItem("user")).name;
  let user = JSON.parse(localStorage.getItem("user"));

  const getProfilePic = async () => {
    const userID = user._id;

    const data = await getProfileInfo(userID);
    if (data.data) {
      const dat = data.data;
      setpic(ddns + '/userfiles/' + user.email + '/pics/' + dat);
    } else {
      setpic(require("assets/img/theme/team-1-800x800.jpg").default);
    }
  };

  const logOut = async () => {
    
    const token = localStorage.getItem("token");
    if (token) {
      const response = await logout(token);
      const { data } = response;
      if (data.success) {
        //localStorage.removeItem("token");
        //localStorage.removeItem("user");
        localStorage.clear();
        history.push("/auth/login");
      }
    }
  };

  return (
    <>
      <Navbar className="navbar-top navbar-dark" expand="md" id="navbar-main">
        <Container className="d-flex" fluid>
          <Link
            className="h4 mb-0 text-white text-uppercase d-none d-lg-inline-block"
            to="/"
          >
            {props.brandText}
          </Link>
          <Form className="navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex ml-lg-auto justify-content-center middle" >
            <FormGroup className="mb-0">
              <InputGroup className="input-group-alternative">
                {/*<InputGroupAddon addonType="prepend">*/}
                  <InputGroupText>
                    <i className="fas fa-search" />
                  </InputGroupText>
                {/*</InputGroupAddon>*/}
                <Input placeholder="Search" type="text" />
              </InputGroup>
            </FormGroup>
          </Form>
          <Nav className="align-items-center d-none d-md-flex justify-content-end" navbar>
            <UncontrolledDropdown nav>
              <DropdownToggle className="pr-0" nav>
                <Media className="align-items-center">
                  <span className="avatar avatar-sm rounded-circle">
                    <img alt=".a.." src={pic} />
                  </span>
                  <Media className="ml-2 d-none d-lg-block">
                    <span className="mb-0 text-sm font-weight-bold">
                      {username}
                    </span>
                  </Media>
                </Media>
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-arrow" end>
                <DropdownItem className="noti-title" header tag="div">
                  <h6 className="text-overflow m-0">Welcome!</h6>
                </DropdownItem>
                <DropdownItem to="/admin/user-profile" tag={Link}>
                  <i className="ni ni-single-02" />
                  <span>My profile</span>
                </DropdownItem>
                <DropdownItem to="/admin/newpass" tag={Link}>
                  <i className="ni ni-key-25" />
                  <span>Change Password</span>
                </DropdownItem>
                <DropdownItem to="/admin/user-profile" tag={Link}>
                  <i className="ni ni-settings-gear-65" />
                  <span>Settings</span>
                </DropdownItem>
                <DropdownItem to="/admin/user-profile" tag={Link}>
                  <i className="ni ni-calendar-grid-58" />
                  <span>Activity</span>
                </DropdownItem>
                <DropdownItem to="/admin/user-profile" tag={Link}>
                  <i className="ni ni-support-16" />
                  <span>Support</span>
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem href="#pablo" onClick={logOut}>
                  <i className="ni ni-user-run" />
                  <span>Logout</span>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
        </Container>
      </Navbar>
    </>
  );
};

export default AdminNavbar;
